<template>
  <div class="pt-4 mx-auto h-screen">
    <p class="font-semibold tracking-wider text-gray-500 pl-8">STEP 5/5</p>
    <p class="mb-2 text-2xl font-semiboldtracking-widest pl-8">Preview</p>
    <PreviewQuote />
  </div>
</template>

<script>
import PreviewQuote from "~/components/app/PreviewQuote";
export default {
  name: "Preview",

  components: {
    PreviewQuote
  }
};
</script>

<style></style>
